export const TOKEN_STATUS = {
  PENDING: 'pending',
  TRANSFER_PENDING: 'transfer_pending',
  EXCHANGE_PENDING: 'exchange_pending',
  BURN_PENDING: 'burn_pending',
  COMMITTED: 'committed',
  BURN: 'burn',
}
